import BaseWidget from "common/widgets/base/BaseWidget";
import DFButton from "app/widgets/DFButton/DFButton";
import locale from "common/managers/locale";
const ManyInput = BaseWidget(kendo.ui.Widget).extend({
    options: {
        name: "ManyInput",

        //This should be the widget class that needs created in each row
        widget: null,

        // Any options to send to the widget for each row upon creation
        widgetOptions: {},

        // The template used to render new inputs
        template: "<input>",

        // Whether enter key should automatically add a new item
        addOnEnter: true
    },

    events: [
        "change",
        "inputCreated"
    ],

    init: function() {
        kendo.ui.Widget.fn.init.apply(this, arguments);
        var id = this.element.attr("id");
        if (!id) {
            console.error("ManyInput widget requires an id");
        }
        if (!this.element.attr("name")) {
            this.element.attr("name", id);
        }
        this.element.wrap($("<div>"));
        this.wrapper = this.element.parent();
        this.wrapper.addClass("manyInputWrapper");
        this.element.hide();
        this.inputs = [];
        this._add();
    },

    _getLabelID: function() {
        var id = this.element.attr("aria-labelledby");
        if (!id) {
            var label = $("label[for='" + this.element.attr("id") + "']");
            if (!label.attr("id")) {
                label.attr("id", kendo.guid());
            }
            var ret = label.attr("id");
            this.element.attr("aria-labelledby", ret);
            return ret;
        } else {
            return id;
        }
    },

    _setIds() {
        this.inputs.forEach((input, index) => {
            this._setId(input.wrapper, input.widget.element, input.add.element, input.remove.element, index);
        });
    },

    _setId(inputWrapper, input, add, remove, index) {
        const root = `${this.element.attr("id")}_option${index}`;
        inputWrapper.attr("id", root);
        input.attr({
            "id": `${root}_input`,
            "name": `${root}_input`
        });
        add.attr("id", `${root}_add`);
        remove.attr("id", `${root}_remove`);
    },

    /**
     * Add a single input.
     * @private
     */
    _add: function() {
        var index = this.inputs.length;
        var single = $("<div>").addClass("inputWrapper");
        var input = $(this.options.template);
        const addText = $("<span>").text(locale.get("add"));
        const addIcon = $("<span>").addClass("addIcon").text("a").attr("aria-hidden", "true");
        var add = $("<button>").addClass("addMany secondary").append(addIcon).append(addText);
        var remove = $("<button>").text(locale.get("remove")).addClass("remove secondary");
        this._setId(single, input, add, remove, index);
        remove.attr("aria-describedby", this._getLabelID() + " " + input.attr("id"));
        add.attr("aria-describedby", this._getLabelID());
        input.attr("aria-labelledby", this._getLabelID());
        if(this.element.is("[required]")) {
            input.attr("required", "required");
        }
        var buttonWrapper = $("<span>").addClass("buttons");
        single.append(input);
        buttonWrapper.append(add);
        buttonWrapper.append(remove);
        single.append(buttonWrapper);
        single.insertBefore(this.element);

        if (this.options.addOnEnter) {
            input.off("keydown.manyInput").on("keydown.manyInput", function(e) {
                //This only applies to indexing right now. enter binding prevents keyup in most places
                if (e.which === kendo.keys.ENTER) {
                    data.addAction();
                    // ensure the enter key isn't handled on parent listeners
                    e.stopPropagation();
                }
            });
        }
        // ensure the enter key isn't handled on parent listeners
        add.add(remove).off("keydown.manyInput").on("keydown.manyInput", function(e) {
            if (e.which === kendo.keys.ENTER) {
                e.stopPropagation();
            }
        });

        var me = this;
        var data = {
            wrapper: single,
            widget: new(this.options.widget)(input, $.extend(this.getWidgetOptions(), {
                change: function() {
                    me._change();
                },
                dataBound: function(e) {
                    e.sender.trigger("cascade");
                },
                blurred: () => {
                    this.element.trigger("blur");
                },
            })),
            focus: function() {
                setTimeout(function() {
                    if (data.widget.focus) {
                        data.widget.focus();
                    }
                }, 100);
            },
            addAction: function() {
                me._add();
                me._hideAdd();
                me.inputs[me.inputs.length - 1].focus();
            },
            add: new DFButton(add, {
                click: function() {
                    data.addAction();
                }
            }),
            remove: new DFButton(remove, {
                click: function() {
                    data.destroy();
                    var index = me.inputs.indexOf(data);
                    me.inputs.splice(index, 0);
                    me.inputs = me.inputs.filter(function(input) {
                        return input !== data;
                    });
                    var focusFirst = false;
                    if (me.inputs.length == 0) {
                        me._add(true);
                        focusFirst = true;
                    } else {
                        me._setIds();
                    }
                    me._hideAdd();
                    me._change();
                    me.trigger("inputRemoved", data);
                    if (focusFirst) {
                        me.inputs[0].focus();
                    } else {
                        var goTo = me.inputs.length > index ? index : (index - 1);
                        setTimeout(function() {
                            me.inputs[goTo].remove.focus();
                        }, 100);
                    }
                }
            }),
            enable: function(to) {
                data.widget.enable(to);
                data.add.enable(to);
                data.remove.enable(to);
            },
            readonly: function(to) {
                data.widget.readonly(to);
                me.styleReadonly(data.widget, to);
                data.add.readonly(to);
                data.remove.readonly(to);
            },
            destroy: function() {
                me.cleanup(data.widget);
                data.widget.destroy();
                data.add.destroy();
                data.remove.destroy();
                data.wrapper.remove();
            }
        };
        this.inputs.push(data);
        if (this._readonlyState) {
            data.readonly(true);
        }
        this.applyExtraOption(data.widget);

        this.trigger("inputCreated", data);
    },

    getWidgetOptions: function() {
        return this.options.widgetOptions || {};
    },

    /**
     * Extension point to apply extra properties that need to be dynamic.
     * @param widget
     */
    applyExtraOption: function(widget) {

    },

    /**
     * Extension point to style the readonly state of the widget.
     *
     * This must be done because the readonly binding often impacts styling.  That can be changed easily.
     * Forms relies on the readonly styling not happening.  As a result, extensions of ManyInput may want to manually
     * control readonly styling.
     * @param widget
     * @param readonly
     */
    styleReadonly: function(widget, readonly) {

    },

    /**
     * Extension point.
     * A widget is about to be removed. Any necessary cleanup beyond just destroy() needs to be done.
     * @param widget
     */
    cleanup: function(widget) {

    },

    /**
     * Extension point that can be called to forcefully reset all extra properties.
     */
    reapplyAllExtraOptions: function() {
        this.inputs.forEach(function(data) {
            this.applyExtraOption(data.widget);
        }, this)
    },

    setDescribedBy: function(category, describedById) {
        for (var i = 0; i < this.inputs.length && this.inputs[i].widget.setDescribedBy; i++) {
            this.inputs[i].widget.setDescribedBy(category, describedById);
        }
    },

    initFocusableEvents: function() {

    },

    destroyFocusable: function() {},

    /**
     * Show add button only on last.
     * @private
     */
    _hideAdd: function() {
        for (var i = 0; i < this.inputs.length; i++) {
            var isLast = (this.inputs.length - 1 === i);
            var show = isLast && !this._readonlyState;
            this.inputs[i].add.element.toggle(show);
        }
    },

    destroy: function() {
        for (var i = 0; i < this.inputs.length; i++) {
            this.inputs[i].destroy();
        }
        this.inputs = [];
        kendo.ui.Widget.fn.destroy.call(this);
    },

    enable: function(enabled) {
        var to = enabled ? true : false;
        for (var i = 0; i < this.inputs.length; i++) {
            this.inputs[i].enable(to);
        }
    },

    _readonlyState: false,

    /**
     * Readonly setter.
     */
    readonly: function(readonly) {
        var to = !!readonly;
        this._readonlyState = to;
        for (var i = 0; i < this.inputs.length; i++) {
            this.inputs[i].readonly(to);
        }
        if (!to) {
            this._hideAdd();
        }
    },

    _change: function() {
        this.trigger("change");
    },

    /**
     * Value getter/setter.
     * @param v value to set. Must be an array or null
     * @returns {*} value from getter
     */
    value: function(v) {
        if (v === undefined) {
            return this.inputs
                .map(function(input) {
                    return input.widget.value();
                })
                .filter(function(value) {
                    return value !== "" && value !== null && value !== undefined;
                });
        } else {
            if (v === null) {
                v = [];
            }
            var current = this.value();
            var allIdentical = (current.length === v.length) && v.every(function(item, i) {
                return current[i] === item;
            });
            if (allIdentical) {
                return;
            }
            var count = Math.max(v.length, 1);
            while (this.inputs.length < count) {
                this._add();
            }
            while (this.inputs.length > count) {
                var last = this.inputs.pop();
                last.destroy();
            }
            this._hideAdd();
            for (var i = 0; i < v.length; i++) {
                this.inputs[i].widget.value(v[i]);
            }
            if (v.length === 0) {
                this.inputs[0].widget.value(null);
            }
        }
    },

    valueForValidation: function() {
        return this.value().join("");
    },

    focus: function() {
        if (this.inputs.length) {
            this.inputs[0].widget.focus();
        }
    },

    /**
     * Gets the collection of elements that can receive focus
     * @param showAll {boolean} Whether to return all widgets or just the visible ones
     * @returns {jQuery} collection of jquery elements that represent the tab order of the many inputs
     */
    getFocusWidgets: function(showAll) {
        var els = [];
        for (var i = 0; i < this.inputs.length; i++) {
            var input = this.inputs[i];
            els.push(input.widget);
            if (showAll === true || this.inputs.length - 1 === i && !this._readonlyState) {
                els.push(input.add);
            }
            els.push(input.remove);
        }
        return els;
    }
});
kendo.ui.plugin(ManyInput);
export default ManyInput;
